import React from 'react'
import loader from '../../img/loading-dog.gif';

//muestra la orden con detalle si el cliente esta logueado, donde al precionar el boton refrescar simula una actualizacion de estado!

const OrderUser = ({id,buyer,fecha,showLoading,actu,items,status}) => {

    
    return (
        <section className="section section-xl bg-default">
            <div className="container">
               {items.cart ? <div className="table-custom-detail">
                    <button onClick={()=>showLoading()} className="btn refresh"><i className="fas fa-sync-alt"></i></button>
                        <div>
                            {buyer.displayName && <p>Nombre Usuario: {buyer.displayName}</p>}
                            <p>Email: {buyer.email}</p>
                        </div>
                        <table className="table-custom table-cart">
                        <thead>
                            <tr>
                                <th>orden N° {id}</th>
                                <th>Nombre Producto</th>
                                <th>Precio</th>
                                <th>Cantidad</th>
                            </tr>
                        </thead>
                        <tbody>
                                {items.cart.map(x=> 
                            
                            <tr key={x.id}>
                                <td><img src={x.imag} alt="producto" className="img-table"/></td>
                                <td>{x.description}</td>
                                <td>${x.precio}</td>
                                <td>
                                    <div className="table-cart-stepper">
                                    {x.qty}
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            )}
                            
                        </tbody>
                    </table>
                    <div className="pieTablaOrder">
                        <p className="estado">Fecha de Compra: {fecha(items.date)}</p>
                        <p className="estado">Estado: <span className={actu}>{status}</span></p>
                        <div className="totalCheck">Total ${items.total}</div>
                    </div>
                 </div> : <img src={loader} className="loader" alt="loader"/>}      
            </div>    
        </section>
    )
}

export default OrderUser
